import callApi from './callApi';

export const generateTestPlan = (data) => {
  const url = `testcases/generate-test-plan`;
  return callApi(url, {}, 'POST', data);
};

export const createTestCycleWithPlan = async (payload, projectId) => {
  const url = `testcases/create-test-cycle?projectId=${projectId}`;
  const headers = {
    'Content-Type': 'application/json',
  };
  let body = {
    ...payload,
  };
  return await callApi(url, headers, 'POST', body);
};